window.addEventListener("load", function () {
    if ( document.querySelectorAll('svg.dots_yellow').length ) {

        gsap.registerPlugin(ScrollTrigger);

        let tl = gsap.timeline({scrollTrigger:{
            trigger:".productInfos",
            start:"top 50%",
            end:"bottom top",
            scrub: 1
        }})
        .to('svg.dots_yellow circle', {xPercent: 200, yPercent: -200, repeat: 10, ease: 'none', duration: 1})
        .from('svg.dots_yellow .small', {scale: 0, repeat: 10, ease: 'none', transformOrigin: "50% 50%", duration: 1}, "<")
        .to('svg.dots_yellow .large', {scale: 0, repeat: 10, ease: 'none', transformOrigin: "50% 50%", duration: 1}, "<")
    }
});
